import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroup,
  Col,
  Label,
  Spinner,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import { getSchoolNameByStateAndCounty } from "store/actions/authDataAction";
import { getCollegeCity } from "store/actions/authDataAction";
import { getCollegeNameByStateAndCity } from "store/actions/authDataAction";
import { getSchoolCounty } from "store/actions/authDataAction";
import { fetchSchoolStates } from "store/actions/authDataAction";
import { fetchCollegeStates } from "store/actions/authDataAction";
import firebase from "../../config/firebase";
import { register } from "store/actions/authAction";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { isSchoolExist } from "store/actions/authAction";
import { adminChangeRequest } from "store/actions/authAction";
import cross from "../../assets/img/cross.svg";
import { emailForChangingRequest } from "store/actions/authAction";
import showImg from "../../assets/img/custom/collectiveRegistration.jpg";

const RegisterAsCollective = () => {
  let dispatch = useDispatch();
  const fileInputRef1 = useRef(null);
  let history = useHistory();
  const [acknowledgeForAdmin, setAcknowledgeForAdmin] = useState(false);
  const [data, setData] = useState({
    img: "",
    collective: "",
    address: "",
    phone: "",
    name: "",
    email: "",
    password: "",
    state: "",
    county: "",
    instituteName: "",
    instituteLevel: "College",
    type: "collective",
    role: "school-admin",
    contract: true,
    status: "pending",
    ip_contract: false,
    created_at: firebase.firestore.FieldValue.serverTimestamp(),
  });
  console.log(data);

  const [loader, setLoader] = useState(false);
  const [yesLoader, setYesLoader] = useState(false);
  const [changeSchoolAdminModal, setChangeSchoolAdminModal] = useState(false);
  const [adminData, setAdminData] = useState("");
  const toggleModal = () => {
    setChangeSchoolAdminModal(!changeSchoolAdminModal);
  };
  const { schoolStates, collegeStates, county, city, schools, college } =
    useSelector((state) => state.authData);
  useEffect(() => {
    dispatch(fetchCollegeStates());
    dispatch(fetchSchoolStates());
  }, []);
  useEffect(() => {
    if (data.state != "") {
      if (data.instituteLevel == "College") {
        dispatch(getCollegeCity(data.state));
      } else {
        dispatch(getSchoolCounty(data.state));
      }
    }
  }, [data.state]);
  useEffect(() => {
    if (data.county != "") {
      if (data.instituteLevel == "College") {
        dispatch(getCollegeNameByStateAndCity(data.state, data.county));
      } else {
        dispatch(getSchoolNameByStateAndCounty(data.state, data.county));
      }
    }
  }, [data.county]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getStateOptions = () => {
    const states =
      data.instituteLevel === "High School" ? schoolStates : collegeStates;
    return states.map((item, index) => (
      <option key={index} value={item.name}>
        {item.name}
      </option>
    ));
  };

  const getCountyOptions = () => {
    const newData = data.instituteLevel === "High School" ? county : city;
    return newData.map((item, index) => (
      <option
        key={index}
        value={data.instituteLevel === "High School" ? item.county : item.city}
      >
        {data.instituteLevel === "High School" ? item.county : item.city}
      </option>
    ));
  };
  const getInstituteOptions = () => {
    const instituteList =
      data.instituteLevel === "High School" ? schools : college;
    return instituteList.map((item) =>
      item.institutes.map((institute, index) => (
        <option key={index} value={institute}>
          {institute}
        </option>
      ))
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    dispatch(
      isSchoolExist(data, (res) => {
        if (res == "success") {
          dispatch(
            register(data, (res) => {
              setLoader(false);
              if (res == "success") {
                setData({
                  name: "",
                  email: "",
                  password: "",
                  state: "",
                  county: "",
                  instituteName: "",
                  instituteLevel: "College",
                  type: "collective",
                  role: "school-admin",
                  contract: true,
                  status: "pending",
                  created_at: firebase.firestore.FieldValue.serverTimestamp(),
                });
                history.push("/auth/login");
              }
            })
          );
        } else if (res == "error") {
          setLoader(false);
        } else {
          setLoader(false);
          setAdminData(res);
          toggleModal();
        }
      })
    );
  };

  const handleChangeAdminRequest = () => {
    setYesLoader(true);
    let { password, ...updateData } = data;
    let newData = {
      ...updateData,
      schoolAdminId: adminData.id,
    };
    let emailData = {
      adminEmail: adminData.email,
      adminName: adminData.name,
      requestEmail: data.email,
      requestName: data.name,
    };
    dispatch(
      adminChangeRequest(newData, () => {
        dispatch(emailForChangingRequest(emailData));
        handleRejectRequest();
        setYesLoader(false);
      })
    );
  };
  const handleRejectRequest = () => {
    toggleModal();
    setData({
      name: "",
      email: "",
      password: "",
      state: "",
      county: "",
      instituteName: "",
      instituteLevel: "College",
      type: "collective",
      role: "school-admin",
      contract: true,
      status: "pending",
      created_at: firebase.firestore.FieldValue.serverTimestamp(),
    });
  };

  return (
    <>
      <Col xs="12" className="my-2 ">
        <Row className="d-flex justify-content-center">
          <Col md="6" className="mb-2 mb-md-0">
            <Card
              className="h-100 p-2 d-flex justify-content-center
    align-items-center "
            >
              <img src={showImg} width="100%" />
            </Card>
          </Col>
          <Col md="6">
            <Card className="h-100 p-2 school_note_registration">
              <h1 className="text-center">TAKES 10 SECONDS</h1>
              <h3 className="bg-white  p-2">
                <ol>
                  <li>Have Staff Assistant photograph your ID Badge.</li>
                  <li>
                    Have Staff Assistant register you at{" "}
                    <span className="bold_text">
                      Fans<span className="primary">Help</span>
                      <span className="red">Players</span>
                    </span>
                    .com
                  </li>
                  <li>
                    Staff Assistant then registers herself as second user and
                    works online, registering other users and carrying out
                    executive's instructions.
                  </li>
                </ol>
              </h3>
            </Card>
          </Col>
        </Row>
      </Col>
      <Col lg="6" md="8">
        <Card className="bg-secondary shadow border-0">
          <CardBody className="px-lg-5 py-lg-5">
            <div className="text-center text-muted mb-4">
              <small>Sign up</small>
            </div>
            <Form role="form" onSubmit={handleSubmit}>
              <FormGroup>
                <Label className="mt-3 auth-label">
                  Click for College or High School
                </Label>
                <div className="d-flex ml-4 mt-2">
                  <div>
                    <Input
                      type="radio"
                      checked={data.instituteLevel === "College"}
                      id="college"
                      name="instituteLevel"
                      value="College"
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          state: "",
                          county: "",
                          instituteName: "",
                          instituteLevel: e.target.value,
                        }));
                      }}
                    />
                    <Label
                      for="college"
                      className={`auth-label ${
                        data.instituteLevel === "College" ? "text-primary" : ""
                      }`}
                    >
                      College
                    </Label>
                  </div>
                  <div className="mx-auto">
                    <Input
                      type="radio"
                      id="highSchool"
                      name="instituteLevel"
                      checked={data.instituteLevel === "High School"}
                      value="High School"
                      onChange={(e) => {
                        setData((prev) => ({
                          ...prev,
                          state: "",
                          county: "",
                          instituteName: "",
                          instituteLevel: e.target.value,
                        }));
                      }}
                    />
                    <Label
                      for="highSchool"
                      className={`auth-label ${
                        data.instituteLevel === "High School"
                          ? "text-primary"
                          : ""
                      }`}
                    >
                      High School
                    </Label>
                  </div>
                </div>
              </FormGroup>
              <div className=" d-flex flex-column align-items-start mb-3">
                <Label className="auth-label mt-4">
                  Person's ID Card Image
                </Label>
                <Input
                  type="file"
                  ref={fileInputRef1}
                  required
                  name="player_img"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      img: e.target.files[0],
                    }))
                  }
                />
                {data.img && (
                  <div className="position-relative mt-3">
                    <img
                      src={URL?.createObjectURL(data.img)}
                      alt=""
                      className=" mt-2"
                      width={80}
                      height={80}
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      style={{
                        top: "-11%",
                        left: "80%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setData((prev) => ({
                          ...prev,
                          img: "",
                        }));
                        fileInputRef1.current.value = "";
                      }}
                    />
                  </div>
                )}
              </div>
              <FormGroup>
                <Label for="collective">Collective Corporation Name</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="collective"
                    placeholder="Collective"
                    type="text"
                    value={data.collective}
                    onChange={handleChange}
                    name="collective"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="address">Address</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="address"
                    placeholder="Address"
                    type="text"
                    value={data.address}
                    onChange={handleChange}
                    name="address"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="phone">Phone</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="phone"
                    placeholder="Enter Phone Number"
                    type="text"
                    value={data.phone}
                    onChange={handleChange}
                    name="phone"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="name">Name</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="name"
                    placeholder="Name"
                    type="text"
                    value={data.name}
                    onChange={handleChange}
                    name="name"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="email">Email</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="email"
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                    value={data.email}
                    onChange={handleChange}
                    name="email"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="password">Password</Label>
                <InputGroup className="input-group-alternative">
                  <Input
                    id="password"
                    placeholder="Password"
                    type="password"
                    autoComplete="new-password"
                    value={data.password}
                    onChange={handleChange}
                    name="password"
                    required
                  />
                </InputGroup>
              </FormGroup>

              {/* <FormGroup>
                <Label for="type">Type</Label>
                <Input
                  required
                  type="select"
                  name="type"
                  id="type"
                  value={data.type}
                  onChange={handleChange}
                  className="input-group-alternative"
                >
                  <option value="">Select Type</option>
                  <option value="school platform">School Platform</option>
                  <option value="collective">Collective</option>
                </Input>
              </FormGroup> */}
              <FormGroup>
                <Label for="state">State</Label>
                <Input
                  required
                  type="select"
                  name="state"
                  id="state"
                  value={data.state}
                  onChange={handleChange}
                  className="input-group-alternative"
                >
                  <option value="">Select State</option>
                  {getStateOptions()}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label for="county">
                  {data.instituteLevel == "College" ? "City" : "County"}
                </Label>
                <Input
                  required
                  type="select"
                  name="county"
                  id="county"
                  value={data.county}
                  onChange={handleChange}
                  className="input-group-alternative"
                  disabled={data.state == ""}
                >
                  <option value="">
                    Select{" "}
                    {data.instituteLevel == "College" ? "City" : "County"}
                  </option>
                  {getCountyOptions()}
                </Input>
              </FormGroup>

              <FormGroup>
                <Label for="instituteName">School</Label>
                <Input
                  required
                  type="select"
                  name="instituteName"
                  id="instituteName"
                  value={data.instituteName}
                  onChange={handleChange}
                  className="input-group-alternative"
                  disabled={data.county == ""}
                >
                  <option value="">Select School</option>
                  {getInstituteOptions()}
                </Input>
              </FormGroup>

              <div>
                <Input
                  required
                  type="checkbox"
                  className="custom-checkbox m-0"
                  checked={acknowledgeForAdmin}
                  onChange={(e) => setAcknowledgeForAdmin(e.target.checked)}
                />
                <Label className="custom-checkbox-label text-dark mx-4 px-3 mt-0">
                  I acknowledge and agree that FHP Admin can investigate,
                  verify, and share my credentials and identity with any third
                  party at any time, at FHP Admin’s sole discretion, to promote
                  data security.
                </Label>
              </div>

              <div className="text-center">
                <Button
                  className="mt-4"
                  color="primary"
                  type="submit"
                  disabled={loader || !acknowledgeForAdmin || data.img == ""}
                >
                  {loader ? <Spinner size="sm" /> : "Create account"}
                </Button>
              </div>
            </Form>
            <div className="mt-3 mx-0 mx-md-3 text-center">
              <Label className="auth-label">Already have an account?</Label>{" "}
              <Link to="/auth/login">
                <Label
                  className="text-primary auth-label"
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  <b>
                    <u>Login</u>
                  </b>
                </Label>
              </Link>
            </div>
          </CardBody>
        </Card>
      </Col>
      <Modal isOpen={changeSchoolAdminModal} centered toggle={toggleModal}>
        <ModalBody>
          <div>
            {adminData !== "" && (
              <b>
                {adminData.name} is already the school admin. His email is{" "}
                {adminData.email}. If you want to change the admin, click the
                "Yes" button
              </b>
            )}
          </div>
          <div className="text-right">
            <Button color="danger" onClick={handleRejectRequest}>
              No
            </Button>
            <Button
              color="primary"
              onClick={handleChangeAdminRequest}
              disabled={yesLoader}
            >
              {yesLoader ? <Spinner size="sm" /> : "Yes"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default RegisterAsCollective;
